import { useEffect, useState } from 'react';

import { useSession } from '@eneco/auth';
import { postEnecoBeXapiSiteApiV1AccountsByAccountNumberAdvanceAmountsRecommended } from '@eneco/dc-be/client';
import useAuthenticatedDCBE from '@eneco/dc-be/hooks/useAuthenticatedDCBE';

const CACHE_DURATION_MS = 1000 * 60 * 60 * 24; // 24 hours;
const CACHE_KEY = `recommended-advance-amount`;

export const useRecommendedAdvanceAmountCaching = ({ crmAccountNumber }: { crmAccountNumber: string }) => {
  const { data: session } = useSession();
  const [shouldFetch, setShouldFetch] = useState(false);

  const { data } = useAuthenticatedDCBE(
    postEnecoBeXapiSiteApiV1AccountsByAccountNumberAdvanceAmountsRecommended,
    {
      path: {
        accountNumber: crmAccountNumber,
      },
    },
    [`/accounts/{accountNumber}/advance-amounts/recommended`],

    session,
    { shouldFetch },
  );

  useEffect(() => {
    if (!session || !crmAccountNumber) return;
    // todo feature flag this again
    // const isRAAFetchingEnabled = env('ENABLE_RAA_FETCHING') === '1';
    // if (!isRAAFetchingEnabled) return;

    const lastFetched = localStorage.getItem(`${CACHE_KEY}:${crmAccountNumber}`);
    const now = Date.now();

    if (!lastFetched || now - Number(lastFetched) > CACHE_DURATION_MS) {
      setShouldFetch(true);
    }
  }, [session, crmAccountNumber]);

  useEffect(() => {
    if (data?.response.ok) {
      setShouldFetch(false);
      localStorage.setItem(`${CACHE_KEY}:${crmAccountNumber}`, Date.now().toString());
    }
  }, [crmAccountNumber, data?.response]);
};
